import { render, staticRenderFns } from "./listChatBot.vue?vue&type=template&id=584a09c5&scoped=true"
import script from "./listChatBot.vue?vue&type=script&lang=js"
export * from "./listChatBot.vue?vue&type=script&lang=js"
import style0 from "./listChatBot.vue?vue&type=style&index=0&id=584a09c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a09c5",
  null
  
)

export default component.exports